import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';

const FlashNotification = ({ message, type, onClose }) => {
  const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';

  return (
    <div className={`fixed top-4 right-4 ${bgColor} text-white px-4 py-2 rounded-lg shadow-lg flex items-center`}>
      <span>{message}</span>
      <button onClick={onClose} className="ml-2 focus:outline-none">
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default FlashNotification;